module.exports = __webpack_public_path__ + "img/qianshu.08713bfe.png";